export default __webpack_public_path__ + "assets/models/601189ed247ecfa482efdbd34a93f9d0.glb";